import { CANARY_MISSION } from '@/enum/enum'
import IconsHomePage from './IconsHomePage'

export const HeroArea = () => {
  return (
    <div className="sm:h-[820px] h-[620px] w-full bg-black">
      <div className="relative h-full w-full">
        <video
          className="w-full h-full absolute inset-0 object-cover hidden sm:block"
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          poster="poster.jpg"
          style={{ width: '100%', objectFit: 'cover' }}
        >
          <source src="home-desktop-cut-black-faststart.mp4" type="video/mp4" media="(min-width: 640px)" />
        </video>
        <video
          className="w-full sm:hidden block"
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          poster="poster-mobile.png"
          style={{ width: '100%', objectFit: 'cover' }}
        >
          <source src="home-mobile-cut-black-faststart.mp4" type="video/mp4"  />
        </video>
        <div className="absolute inset-0 bg-gradient-to-t from-black from-40% to-transparent to-45% z-10 sm:hidden" />
      </div>
      <div className="absolute md:top-[150px] top-[100px] flex items-center justify-center z-10 flex-col w-full">
        <div className="flex flex-col">
          <h1 className="text-white text-[80px] leading-none lg:text-8xl xl:text-9xl text-center drop-shadow-[0_1px_2px_rgba(0,0,0,0.75)] tracking-wide sm:pt-[100px] pt-[45px]">
            {CANARY_MISSION.NAME.toUpperCase()}
          </h1>
          <div className="md:w-fit w-full sm:pt-0 pt-[220px]">
            <IconsHomePage />
            <div className="flex flex-col items-center">
              <div className="text-white sm:text-[1.4rem] text-sm italic ">
                Because the world should know.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default HeroArea
